import { JobsiteBadgeTemplateOption } from 'containers/worker/helpers/utils';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { StaticTempBadgePreview } from './StaticTempBadgePreview';

export type TempBadgePreviewProps = {
  jobsiteName: string;
  className?: string;
};

export function TempBadgePreview(
  props: TempBadgePreviewProps,
): React.ReactElement | null {
  const { jobsiteName, className } = props;
  const badgeNameValue = useWatch<string>({ name: 'badgeName' });
  const badgeTemplateValue = useWatch<JobsiteBadgeTemplateOption>({
    name: 'jobsiteBadgeTemplate',
  });

  return (
    <StaticTempBadgePreview
      templateName={badgeTemplateValue?.value}
      badgeName={badgeNameValue || '[Badge Name]'}
      jobsiteName={jobsiteName}
      className={className}
    />
  );
}
